import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=d3fefbba&scoped=true&"
import script from "./Recordings.vue?vue&type=script&lang=ts&"
export * from "./Recordings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fefbba",
  null
  
)

export default component.exports